import type {FinancingEndingReminderVehicle} from '@dms/api/core';

const HTML_ENTITIES: Readonly<Record<string, string>> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

const escapeHtml = (text: string) =>
  text.replace(/[&<>"']/g, (char) => HTML_ENTITIES[char] ?? char);

/**
 * Tells apart reminder lines of the same customer and vehicle title: ", <plate or VIN>" and
 * " (<business case number>)", each only when known. The reminder message is HTML, so the values
 * are escaped here as the translation escapes its own.
 */
export const getFinancingEndingReminderVehicleSuffix = (
  vehicle: FinancingEndingReminderVehicle
) => {
  const identifier = vehicle.registrationPlate || vehicle.vin;
  const businessCaseNumber = vehicle.businessCaseNumber;

  return [
    identifier ? `, ${escapeHtml(identifier)}` : '',
    businessCaseNumber ? ` (${escapeHtml(businessCaseNumber)})` : '',
  ].join('');
};
